import type { SelectChangeEvent } from "@mui/material";
import { FormControl, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import { autoFormatCamelCase } from "@entrilia/shared/utilities/stringHelper";
import type { DataCollectionRequestAuditory } from "../../../../api/types/dataCollectionTypes";
import { allDataCollectionRequestAuditoryValues } from "../../../../api/types/dataCollectionTypes";
import type { ObjectAccessCategory, ObjectClassDefinition } from "../../../../api/types/objectTypes";
import type { EditDataRequestTemplateState } from "./editDataRequestTemplateState";
import { getCategoriesForAuditory } from "./editDataRequestTemplateState";

interface Props {
  auditory: DataCollectionRequestAuditory | "";
  categoryId: string;
  categories: ObjectAccessCategory[];
  objectDefinition: ObjectClassDefinition;
  onChange: (changes: Pick<EditDataRequestTemplateState, "auditory" | "categoryId">) => void;
  disabled?: boolean;
}

const DataRequestTemplateRecipientFields = ({
  auditory,
  categoryId,
  categories,
  objectDefinition,
  onChange,
  disabled,
}: Props) => {
  const categoriesForAuditory = getCategoriesForAuditory(auditory, categories, objectDefinition);

  const handleAuditoryChange = (e: SelectChangeEvent<DataCollectionRequestAuditory>) => {
    onChange({ auditory: e.target.value, categoryId: "" });
  };

  const handleCategoryChange = (e: SelectChangeEvent) => {
    onChange({ auditory, categoryId: e.target.value });
  };

  return (
    <Stack direction="row" spacing={1}>
      <FormControl fullWidth>
        <InputLabel id="recipient-type-select-label">Recipient Type</InputLabel>
        <Select fullWidth label="Recipient Type" value={auditory} onChange={handleAuditoryChange} disabled={disabled}>
          {allDataCollectionRequestAuditoryValues.map((value) => (
            <MenuItem key={value} value={value}>
              {autoFormatCamelCase(value)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth>
        <InputLabel id="category-select-label">Category</InputLabel>
        <Select
          fullWidth
          label="Category"
          value={categoryId}
          onChange={handleCategoryChange}
          disabled={disabled || !auditory}
        >
          {categoriesForAuditory.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};

export default DataRequestTemplateRecipientFields;
